require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scribbling-about-how-that-was-bad.json") })
        }
      }, "path---scribbling-about-how-that-was-bad");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scribbling-about-how-that-was-bad!./.cache/json/scribbling-about-how-that-was-bad.json
// module id = 554
// module chunks = 231608221292675